'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "Can you build a custom eCommerce website from scratch?",
    answer: "Yes, Eratec Solution specializes in end-to-end development—from initial wireframes and UX/UI design to database setup and payment gateway integration—creating a fully tailored online store that reflects your brand identity."
  },
  {
    question: "Which eCommerce platforms do you work with?",
    answer: "We’re proficient in popular platforms like react, nextjs, react-native, php, tailwind, bootstrap, worpress and Shopify. If you have a preferred technology stack or need a headless-commerce solution, our team can accommodate those requirements too."
  },
  {
    question: "How do you ensure my site is optimized for mobile and speed?",
    answer: "Our developers follow responsive design best practices and employ performance techniques such as image optimization, lazy loading, and CDN setup. This ensures fast load times and a seamless shopping experience on any device."
  },
  {
    question: "Will I be able to manage products and orders myself?",
    answer: "Absolutely. We provide an intuitive admin dashboard customized to your needs, allowing you to easily add or edit products, track orders, manage inventory, and view sales reports without any technical expertise."
  },
  {
    question: "What’s the typical timeline and cost for a new eCommerce website?",
    answer: "Timelines vary based on complexity, but most standard eCommerce builds take 6–8 weeks from kickoff to launch. Costs depend on features like custom design, third-party integrations, and scale—Eratec Solution will provide a detailed proposal after your free consultation."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
